import React, { useEffect, useState, useLayoutEffect } from "react";

// Components
import PageHeader from "~/common/components/PageHeader";
import NavbarAndSidebarLayout from "~/layouts/NavbarAndSidebarLayout";

// Assets
import "~/assets/sass/pages/apply/applyEval.scss";
import useRequest from "~/common/hooks/useRequest";
import { API_STATE } from "~/common/constants/state";

import ApplyEvalTable from "./applyEvalTable";
import ApplyEvalPopup from "./ApplyEvalPopup";
import { useGlobalStore } from "~/store";
import useDebounce from "~/common/hooks/useDebounce";
import SearchFilter from "~/pages/apply/ApplyEval/SearchFilter";
import { useForm } from "react-hook-form";
import { dateToString } from "~/utils/formatter";
import NotFoundPage from "~/pages/NotFoundPage";
import { useNavigate, useParams } from "react-router";

const ApplyEval = () => {
	const [
		{
			user: { info, company },
		},
	] = useGlobalStore();
	const navigate = useNavigate();
	const { idx } = useParams();
	const [applyResultModal, setApplyResultModal] = useState();
	const listRequest = useRequest("post", "/vc/apply/search/judge");
	const listDetailRequest = useRequest("get", "/vc/apply");
	const [loadingPage, setLoadingPage] = useState(false);
	const [formData, setFormData] = useState({
		industryFields: [],
		investLevels: [],
		page: 1,
		size: 10,
		companyName: "",
	});

	const applyListForm = useForm({
		defaultValues: {
			applyStartDate: new Date().setFullYear(new Date().getFullYear() - 1),
			applyEndDate: new Date(),
		},
	});
	const startDate = applyListForm.watch("applyStartDate");
	const endDate = applyListForm.watch("applyEndDate");

	const [totalNum, setTotalNum] = useState(0);
	const [applyJudgeList, setApplyJudgeList] = useState(null);
	const [applyJudgeDetail, setApplyJudgeDetail] = useState(null);
	const [applyJudgeScore, setApplyJudgeScore] = useState(null);
	const [applyDetail, setApplyDetail] = useState(null);
	const [searchName, setSearchName] = useState("");
	const [userConfig, setUserConfig] = useState(localStorage.getItem("theme"));
	const [searchElement, setSearchElement] = useState({});

	const [pageInfo, setPageInfo] = useState({});


	const onChangeName = useDebounce((e) => {
		setFormData({
			...formData,
			page: 1,
			companyName: e.target.value,
			investLevels: searchElement.scaleSearch ? searchElement.scaleSearch : [],
			industryFields: searchElement.indSearch ? searchElement.indSearch : [],
		});
	}, 1000);

	const handleSearch = () => {
		setFormData({
			...formData,
			page: 1,
			size: 10,
			companyName: searchName,
			investLevels: searchElement.scaleSearch ? searchElement.scaleSearch : [],
			industryFields: searchElement.indSearch ? searchElement.indSearch : [],
			createdFrom: dateToString(startDate, "yyyy-MM-dd"),
			createdTo: dateToString(endDate, "yyyy-MM-dd"),
		});
	};

	//상세 페이지
	const getDetailModal = (idx, judgeList) => {
		// 심사역 배정 이메일로 접속시
		const detail = judgeList
			? judgeList.filter((d) => d.idx === idx)
			: applyJudgeList?.filter((d) => d.idx === idx);
		setApplyDetail(detail[0]);
		listDetailRequest.call(idx, "path");
	};

	const handlePage = (page) => {
		setPageInfo({
			...pageInfo,
			page: page
		});
		setFormData({
			...formData,
			page: page
		})
	}

	useLayoutEffect(() => {
		switch (listRequest.state) {
			case API_STATE.done:
				const requestApplyList = listRequest.response?.data;
				setPageInfo(requestApplyList.pagination);
				// setTotalNum(requestApplyList.pagination.totalCount);
				setApplyJudgeList(requestApplyList.applies);
				setLoadingPage(false);
				idx && getDetailModal(idx, requestApplyList.applies);
				break;
			default:
				break;
		}
	}, [listRequest.state, listRequest.response]);

	useEffect(() => {
		switch (listDetailRequest.state) {
			case API_STATE.done:
				const requestApplyDetailList = listDetailRequest.response?.data;
				setApplyJudgeDetail(requestApplyDetailList.apply);
				setApplyJudgeScore(requestApplyDetailList.myReview);
				setApplyResultModal(true);
				break;
			case API_STATE.error:
				if (listDetailRequest.error.statusCode === 404) {
					navigate("/404");
				}
			default:
				break;
		}
	}, [listDetailRequest.state, listDetailRequest.response]);

	useEffect(() => {
		setLoadingPage(true);
		getListData();
	}, [formData]);

	const getListData = () => {
		listRequest.call(formData);
	};

	useEffect(() => {
		setFormData({
			...formData,
			page: 1,
			size: 10,
			investLevels: searchElement.scaleSearch ? searchElement.scaleSearch : [],
			investStatus: searchElement.statusSearch ? searchElement.statusSearch : [],
			industryFields: searchElement.indSearch ? searchElement.indSearch : [],
		});
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [searchElement]);

	return (
		<NavbarAndSidebarLayout menu={["apply", "evaluate"]} type={"main"}>
			<PageHeader />
			<SearchFilter
				setSearchElement={setSearchElement}
				applyListForm={applyListForm}
				handleSearch={handleSearch}
			/>
			<ApplyEvalTable
				{...{
					setApplyResultModal,
					applyJudgeList,
					onChangeName,
					handleSearch,
					getDetailModal,
					loadingPage,
					pageInfo,
					handlePage
				}}
			/>
			{/*---- 심사하기, 결과보기 모달*/}
			<ApplyEvalPopup
				{...{
					applyResultModal,
					setApplyResultModal,
					info,
					company,
					applyJudgeDetail,
					applyDetail,
					userConfig,
					applyJudgeScore,
					getListData,
				}}
			/>
		</NavbarAndSidebarLayout>
	);
};

export default ApplyEval;
